module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("People living deeply have no fear of death.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "quote-att"
  }, [_vm._v("—Anaïs Nin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The old blue Volvo pulls slowly out of George Washington University, turns right, and creeps down the dark, snowy street. The late-evening traffic is light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie Moment ignores the dashboard light and buzz telling him he hasn’t fastened his seat belt. He sits back and listens to Eliot Karpinsky’s new audiobook on his Volvo’s bashed-up cassette player. The voice blurs and slurs because the car stereo is nearly gone, but he can make it out: “The corporations don’t even want to compete anymore. They stand in line for government handouts, less in need than our poorest poor.” Karpinsky’s tenor voice rings with sour conviction. “Greed is their only mission.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie expels a long, sad “ahhhh.” He thinks of his green years, demonstrating in Chicago as a high school student, the McCarthy campaign. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Hell, no! We won’t go!")]), _vm._v(" In the days when his back was strong, his hair dark brown and long. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Not like today. Not like goddamn gray middle age.")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("His glasses are grimy, so he rubs them with his free hand. The defrost isn’t working well and the car windows keep fogging. Headlights ahead wear halos of red and white. He clicks on his seat belt. A woman’s voice interrupts Karpinsky: “Please insert cassette five for ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("the remainder of chapter twenty-four.” The cassette pops out automatically and the radio comes on.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“. . . today’s hearing on the Whitewater scandal revealed new inconsistencies in the testimony . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn,” says Charlie out loud, turning down the volume. He hates the way they break up audiobook cassettes in the middle of chapters. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Couldn’t they use forty-five minutes per side, instead of thirty?")]), _vm._v(" He flips to a rock station. It’s playing a Fleetwood Mac song, “The Chain,” with Stevie Nicks growling “Damn your love, damn your lies” over a grinding electric guitar. The light ahead turns red and Charlie stops. He undoes his seat belt and leans over to rummage through the cassettes on the floor in front of the passenger seat. Some ungraded exam papers fall off the car seat and slap onto the pile of cassettes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A car horn honks behind him. Charlie looks up and sees that the light has turned green. He steps on the gas, looking down at the jumble of cassettes and exam papers. He dreads the night’s grading, alone in his apartment. It’s his birthday, but he has made a point of not mentioning it to his friends. He doesn’t want to celebrate anything so soon after the final divorce decree. It’s easier to suffer alone, without people trying to cheer him up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He sits back and realizes he should in some abstract sense be satisfied. Still alive, at least. Maybe a bottle of a good Cabernet can rub those cares away. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A blare of horns. A big black semi looms on his right. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("My God, I forgot the damn seat belt. . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a shrill scream of tearing metal, it plows through his right door. Light explodes in his head. Pain cuts sharp across him. The truck rolls over his Volvo, crushing the passenger compartment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Charlie sees a bright-red color. Feels an overwhelming pressure. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Ahhh . . .")]), _vm._v(" A hard, dark nothing swallows him.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-708ad2ac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm01c.vue
// module id = 78
// module chunks = 0